let refreshTokenPromise = null

export default axios => ({
  login (payload) {
    return axios.post('/auth/login', payload)
  },
  logout () {
    return axios.post('auth/logout')
  },

  refreshToken (payload) {
    refreshTokenPromise = axios.get('/auth/refresh', payload)
    refreshTokenPromise.finally(() => {
    })

    return refreshTokenPromise
  },
  profile (payload) {
    return axios.get('/auth/self', payload)
  }
})
